import type { TFunction } from 'i18next';

import { PlatformStatisticResult } from '@/api/statistic/types';
import { formatNumber } from '@/utils';

export const getFormatedNumber = (
	data: PlatformStatisticResult | null | undefined,
	t: TFunction,
) => {
	return [
		{ title: data?.warehouses_count, description: t('about-us-container.warehouses') },
		{ title: data?.companies_count, description: t('about-us-container.fish-companies') },
		{
			title: formatNumber(Math.round((data?.products_stored_volume ?? 0) / 1000)),
			description: t('about-us-container.tons-in-storage'),
		},
		{
			title: formatNumber(Math.round((data?.products_sale_volume ?? 0) / 1000)),
			description: t('about-us-container.tons-for-sale'),
		},
	];
};
